module.exports = __webpack_public_path__ + "static/scale-model-of-grissom-park-in-bakersfield-california-f63130ae88fd2bdd51aca24b3249af95.png";